import type React from 'react';

/**
 * Свои отступы шапки квиза (слово владельца 21.10.2026, Blinkist: логотип на
 * y=24 и x=16, ряд «назад + прогресс» на y=72; у нас вся шапка на 24 px выше и
 * на 12 px правее). Поля `settings.quizHeader.paddingTop` / `paddingX`
 * считаются от края ЭКРАНА, а шапка стоит внутри полей страницы, колонки,
 * холста телефона или слоя фона — и у каждого места поля свои.
 *
 * Поэтому каждый узел, задающий поля вокруг шапки, объявляет их переменными
 * `--quiz-chrome-inset-top` / `--quiz-chrome-inset-x` (страница и прибитая
 * шапка — public-paywall.css, холст — PhonePreview.tsx, слой фона —
 * ScreenBackgroundWrapper.tsx; ближайший узел перебивает дальний), а обёртка
 * шапки сдвигается на «поле минус поля вокруг». Нет поля — стиля нет, разметка
 * шапки прежняя. Переменная не объявлена (неизвестный хост) — поля вокруг
 * считаются нулём: шапка отступает на поле от своей колонки.
 *
 * Содержимое экрана под шапкой сдвигается только на разницу высоты шапки:
 * боковые поля — отрицательные/положительные поля самой обёртки.
 * Граница: геометрию в браузере тесты jsdom не считают — они судят стиль.
 */
export const QUIZ_CHROME_INSET_TOP_VAR = '--quiz-chrome-inset-top';
export const QUIZ_CHROME_INSET_X_VAR = '--quiz-chrome-inset-x';

/** Переменные полей вокруг шапки для узла, который эти поля задаёт. */
export function quizChromeInsetVars(
  top: string,
  x: string,
): React.CSSProperties {
  return {
    [QUIZ_CHROME_INSET_TOP_VAR]: top,
    [QUIZ_CHROME_INSET_X_VAR]: x,
  } as React.CSSProperties;
}

/** Свои поля шапки на её обёртке — из них считаются поля обёртки ниже. */
export const QUIZ_HEADER_PAD_TOP_VAR = '--quiz-header-pad-top';
export const QUIZ_HEADER_PAD_X_VAR = '--quiz-header-pad-x';

/**
 * Стиль обёртки шапки по своим отступам (поля из двери resolveQuizHeader).
 * Само число лежит переменной на обёртке, поле обёртки — «число минус поля
 * вокруг»: так оба видны и в браузере, и в разметке (jsdom отбрасывает
 * `calc()` с `var()` из полей, переменную — нет).
 */
export function quizHeaderInsetStyle(h: {
  paddingTop?: number;
  paddingX?: number;
}): React.CSSProperties {
  const out: Record<string, string> = {};
  if (h.paddingTop !== undefined) {
    out[QUIZ_HEADER_PAD_TOP_VAR] = `${h.paddingTop}px`;
    out.marginTop = `calc(var(${QUIZ_HEADER_PAD_TOP_VAR}) - var(${QUIZ_CHROME_INSET_TOP_VAR}, 0px))`;
  }
  if (h.paddingX !== undefined) {
    const side = `calc(var(${QUIZ_HEADER_PAD_X_VAR}) - var(${QUIZ_CHROME_INSET_X_VAR}, 0px))`;
    out[QUIZ_HEADER_PAD_X_VAR] = `${h.paddingX}px`;
    out.marginLeft = side;
    out.marginRight = side;
    // Ширина — по полям экрана, а не по колонке (раскладка с alignX ставит
    // обёртке width 100% и потолок колонки).
    out.width = 'auto';
    out.maxWidth = 'none';
  }
  return out as React.CSSProperties;
}
